/**
 * 双语固定文案字典（06 开发文档 i18n resources；与原型 T(zh,en) 语义对齐）。
 * key 冻结原则同 contracts——页面消费后不得改名。
 */
export const uiCopy = {
  siteName: { 'zh-CN': '时述智能 Chronuspeak Tech', en: 'Chronuspeak Tech' },
  slogan: { 'zh-CN': '时间共振，故事无限', en: 'TIME IS NOT LINEAR, STORIES ARE ETERNAL.' },
  nav: {
    home: { 'zh-CN': '首页', en: 'Home' },
    builders: { 'zh-CN': '创作人之家', en: "Builders' House" },
    notices: { 'zh-CN': '公告栏', en: 'Noticeboard' },
    contact: { 'zh-CN': '联络站', en: 'Contact Station' },
    about: { 'zh-CN': '时光广场', en: 'Time Square' },
  },
  common: {
    skipToContent: { 'zh-CN': '跳到主要内容', en: 'Skip to main content' },
    // WCAG 2.5.3：visible 文本（EN/中文）必须是 accessible name 子串——文案含 visible token
    switchLanguage: { 'zh-CN': '切换到 English（EN）', en: 'Switch to 中文 (EN)' },
    backHome: { 'zh-CN': '返回小镇', en: 'Back to town' },
    loading: { 'zh-CN': '加载中…', en: 'Loading…' },
    loadFailed: { 'zh-CN': '内容暂时无法加载，请稍后再试。', en: 'Content unavailable. Please try again later.' },
    notFound: { 'zh-CN': '内容不存在或已下线。', en: 'This content does not exist or is offline.' },
    readMore: { 'zh-CN': '展开阅读', en: 'Read more' },
  },
  fallbackNotice: {
    'zh-CN': '此页暂无英文内容，已显示中文。',
    en: 'This page is not yet available in Chinese; showing English.',
  },
  draftBadge: {
    'zh-CN': 'English draft · 未审核',
    en: 'English draft · unreviewed',
  },
  machineTranslatedPrefix: { 'zh-CN': '[机翻未审]', en: '[Machine-translated, unreviewed]' },
} as const;

export type UiCopyKey = keyof typeof uiCopy;

/** 深层取值：copy('nav.home', locale) 形态；未命中返回 path（开发期可见） */
export function copy(path: string, locale: 'zh-CN' | 'en'): string {
  const parts = path.split('.');
  let node: unknown = uiCopy;
  for (const part of parts) {
    if (node && typeof node === 'object' && part in (node as Record<string, unknown>)) {
      node = (node as Record<string, unknown>)[part];
    } else {
      return path;
    }
  }
  if (node && typeof node === 'object' && locale in (node as Record<string, string>)) {
    const v = (node as Record<string, string>)[locale];
    return v ?? path;
  }
  return path;
}
